// context/CurrentUserContext.js

import { createContext, useEffect, useState } from "react";
import MainServices from "../services/MainServices";
import useAuthContext from "../hooks/useAuthContext";
import useSessionContext from "../hooks/useSessionContext"; // ✅ use SessionContext

const CurrentUserContext = createContext({
  currentUser: null,
  setCurrentUser: () => {},
  currentUserChange: false,
  setCurrentUserChange: () => {},
  loading: false,
});

const CurrentUserProvider = ({ children }) => {
  const { userId } = useAuthContext();
  const { session, sessionReady } = useSessionContext(); // ✅ Get session + readiness
  const { getCurrentUserDetails } = MainServices();

  const [currentUser, setCurrentUser] = useState(null);
  const [currentUserChange, setCurrentUserChange] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // ✅ Only fetch if session is ready and userId is available
    if (sessionReady && userId && (currentUserChange || !currentUser)) {
      getCurrentUser();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionReady, userId, currentUserChange]);

  const getCurrentUser = async () => {
    try {
      setLoading(true);
      const response = await getCurrentUserDetails();
      console.log("current user data: ", response);
      setCurrentUser(response?.data?.data || null);
      setCurrentUserChange(false);
    } catch (error) {
      console.error("Error fetching current user", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <CurrentUserContext.Provider
      value={{
        currentUser,
        setCurrentUser,
        currentUserChange,
        setCurrentUserChange,
        loading,
      }}
    >
      {children}
    </CurrentUserContext.Provider>
  );
};

export { CurrentUserContext, CurrentUserProvider };
